@if (gdprMessageType() === 'banner') {
  <ui-gdpr-banner (showBanner)="onShowBanner()" (closeBanner)="onCloseBanner()" />
}
